import { render } from "./AccordionPanel.vue?vue&type=template&id=0bdfe5f0&scoped=true"
import script from "./AccordionPanel.vue?vue&type=script&lang=js"
export * from "./AccordionPanel.vue?vue&type=script&lang=js"

import "./AccordionPanel.vue?vue&type=style&index=0&id=0bdfe5f0&scoped=true&lang=css"

import exportComponent from "/Users/zellwegv/repos-work/ce-365-spiral-curve/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdfe5f0"]])

export default __exports__